import { COLO_ROWS, type ColoRegion } from "./colo-data";
import { distanceKm, type LatLon } from "./geo";

export interface Colo extends LatLon {
  iata: string;
  country: string;
  region: ColoRegion;
  city: string;
}

export const COLOS: readonly Colo[] = COLO_ROWS.map(([iata, lat, lon, country, region, city]) => ({
  iata,
  lat,
  lon,
  country,
  region,
  city,
}));

const BY_IATA = new Map(COLOS.map((c) => [c.iata, c]));

export function coloByIata(iata: string | undefined | null): Colo | undefined {
  if (!iata) return undefined;
  return BY_IATA.get(iata.toUpperCase());
}

export function nearestColo(p: LatLon): Colo {
  let best = COLOS[0]!;
  let bestD = Infinity;
  for (const c of COLOS) {
    const d = distanceKm(p, c);
    if (d < bestD) {
      bestD = d;
      best = c;
    }
  }
  return best;
}

export const REGION_NAMES: Record<ColoRegion, string> = {
  AP: "Asia Pacific",
  NA: "North America",
  EU: "Europe",
  SA: "South America",
  AF: "Africa",
  ME: "Middle East",
  OC: "Oceania",
};
